(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js');
"use strict";


const {
  useState,
  useMemo,
  useCallback
} = React;
const {
  useSearchParams
} = svs.components.casino_react.hooks;
const {
  useGetSearchResultQuery,
  useLazyGetSearchResultQuery,
  useGetListFilterResultQuery,
  useLazyGetListFilterResultQuery
} = svs.components.casino_react.casinoStore.endpoints.searchApi;
const {
  constants: {
    DefaultNumberOfCasinoGridItems
  }
} = svs.components.casino_react.common;
const getHasSearchInput = _ref => {
  let {
    searchQuery,
    tags,
    providers,
    listIds,
    categories,
    sorting
  } = _ref;
  return Boolean(searchQuery || (tags === null || tags === void 0 ? void 0 : tags.length) || (listIds === null || listIds === void 0 ? void 0 : listIds.length) || (providers === null || providers === void 0 ? void 0 : providers.length) || (categories === null || categories === void 0 ? void 0 : categories.length) || (sorting === null || sorting === void 0 ? void 0 : sorting.length));
};
const getHasOnlyListId = _ref2 => {
  let {
    listIds,
    searchQuery,
    tags,
    providers,
    categories,
    sorting
  } = _ref2;
  return Boolean(listIds === null || listIds === void 0 ? void 0 : listIds.length) && !getHasSearchInput({
    searchQuery,
    tags,
    providers,
    categories,
    sorting
  });
};
const buildQueryOptions = shouldSkip => ({
  skip: shouldSkip,
  selectFromResult: result => {
    if (shouldSkip || !(result !== null && result !== void 0 && result.data)) {
      return {
        data: {
          games: null,
          error: null,
          totalCount: null
        }
      };
    }
    return result;
  }
});

const useSearchResults = function () {
  var _listIds$;
  let {
    fetchCount = DefaultNumberOfCasinoGridItems * 3,
    fetchOffset = 0,
    skipGamesSearch = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  const [count] = useState(fetchCount);
  const [offset, setOffset] = useState(fetchOffset);
  const {
    q: queryString,
    tags,
    categories,
    listIds,
    providers: decodedProviders,
    sorting
  } = useSearchParams();
  const providers = decodedProviders === null || decodedProviders === void 0 ? void 0 : decodedProviders.map(encodeURIComponent);
  const hasSearchInput = getHasSearchInput({
    searchQuery: queryString,
    tags,
    providers,
    listIds,
    categories
  });
  const hasOnlyListId = getHasOnlyListId({
    searchQuery: queryString,
    tags,
    providers,
    listIds,
    categories,
    sorting
  });
  const {
    data: searchData,
    isLoading: searchDataIsLoading,
    error: searchDataError,
    isFetching: searchDataIsFetching
  } = useGetSearchResultQuery({
    searchQuery: queryString,
    tags,
    providers,
    listIds,
    categories,
    count,
    offset,
    sorting
  }, buildQueryOptions(skipGamesSearch || hasOnlyListId || !hasSearchInput));
  const [searchFetchMore] = useLazyGetSearchResultQuery();
  const searchFetchMoreOffset = useCallback((offset, count) => {
    searchFetchMore({
      offset,
      count,
      searchQuery: queryString,
      tags,
      providers,
      categories,
      listIds,
      sorting
    });
  }, [categories, listIds, providers, queryString, searchFetchMore, sorting, tags]);
  const {
    data: listData,
    isLoading: listDataIsLoading,
    error: listDataError,
    isFetching: listDataIsFetching
  } = useGetListFilterResultQuery({
    listId: (_listIds$ = listIds === null || listIds === void 0 ? void 0 : listIds[0]) !== null && _listIds$ !== void 0 ? _listIds$ : '',
    count,
    offset
  }, buildQueryOptions(skipGamesSearch || !hasOnlyListId));
  const [listFetchMore] = useLazyGetListFilterResultQuery();
  const listFetchMoreOffset = useCallback((offset, count) => {
    var _listIds$2;
    listFetchMore({
      listId: (_listIds$2 = listIds === null || listIds === void 0 ? void 0 : listIds[0]) !== null && _listIds$2 !== void 0 ? _listIds$2 : '',
      offset,
      count
    });
  }, [listFetchMore, listIds]);
  const result = useMemo(() => ({
    games: hasOnlyListId ? listData === null || listData === void 0 ? void 0 : listData.games : searchData === null || searchData === void 0 ? void 0 : searchData.games,
    totalGamesCount: hasOnlyListId ? listData === null || listData === void 0 ? void 0 : listData.totalCount : searchData === null || searchData === void 0 ? void 0 : searchData.totalCount,
    error: hasOnlyListId ? listDataError : searchDataError,
    isLoading: hasOnlyListId ? listDataIsLoading : searchDataIsLoading,
    isFetching: hasOnlyListId ? listDataIsFetching : searchDataIsFetching,
    latestSearchQuery: queryString,
    offset,
    setOffset,
    fetchMore: hasOnlyListId ? listFetchMoreOffset : searchFetchMoreOffset
  }), [hasOnlyListId, searchData === null || searchData === void 0 ? void 0 : searchData.games, searchData === null || searchData === void 0 ? void 0 : searchData.totalCount, searchDataError, searchDataIsFetching, searchDataIsLoading, searchFetchMoreOffset, listData === null || listData === void 0 ? void 0 : listData.games, listData === null || listData === void 0 ? void 0 : listData.totalCount, listDataError, listDataIsFetching, listDataIsLoading, listFetchMoreOffset, offset, queryString]);
  return result;
};
setGlobal('svs.components.casino_react.casinoStore.hooks.useSearchResults', useSearchResults);

 })(window);